import CardHorizontal from '../modules/CardHorizontal';
import FormItinerario from '../modules/FormItinerario';
import FormularioTour from '../modules/FormularioTour';


export default function BarranquillaPC() {


    const items = [
        { id: 1, folder: 'barranquilla_pc', imagen: 'monumentos.jpg', titulo: 'MONUMENTOS', contenido: 'Explora los monumentos más representativos del Atlántico. En Puerto Colombia se levanta El Faro, emblema histórico que recuerda la conexión marítima de la región. En Barranquilla destaca la colorida Ventana al Mundo, símbolo de diversidad, innovación y progreso. Muy cerca se encuentra la imponente Aleta de Tiburón, tributo a la pasión deportiva y al Junior de Barranquilla, orgullo de su gente. Cada uno de estos íconos refleja historia, arte y cultura caribeña.' }
        ,{ id: 2, folder: 'barranquilla_pc', imagen: 'estatuas.jpg', titulo: 'ESTATUAS SHAKIRA Y SOFIA VERGARA', contenido: 'En el camellón de Barranquilla brillan dos esculturas que rinden homenaje a mujeres que han llevado el nombre de la ciudad al mundo: Shakira y Sofía Vergara. La primera, ícono global de la música, y la segunda, reconocida actriz internacional, representan el talento, la belleza y la energía caribeña. Estas estatuas no solo celebran sus trayectorias, sino también el orgullo barranquillero, convirtiéndose en un punto de encuentro cultural y turístico para locales y visitantes.' }
        ,{ id: 3, folder: 'barranquilla_pc', imagen: 'madera.jpg', titulo: 'CIÉNAGA DE MALLORQUÍN', contenido: 'La Ciénaga de Mallorquín, ubicada en el norte de Barranquilla, es un santuario natural rodeado de manglares y aves migratorias. Este ecosistema único combina belleza paisajística con gran riqueza ambiental, convirtiéndose en un lugar ideal para el ecoturismo, la observación de fauna y el disfrute de la naturaleza en su estado más puro.' }
        ,{ id: 3, folder: 'barranquilla_pc', imagen: 'camellon.jpg', titulo: 'MALECÓN DEL RIO', contenido: 'El Malecón del Río es uno de los espacios más vibrantes de Barranquilla. A orillas del Magdalena, combina naturaleza, cultura y recreación en un entorno moderno y acogedor. Con zonas peatonales, miradores y actividades al aire libre, es el lugar perfecto para disfrutar del atardecer, compartir en familia y sentir la esencia del Caribe colombiano.' }
    ];


    return (
        <div >

            <FormularioTour titulo='TOUR BARRANQUILLA - PUERTO COLOMBIA'>
                <div>
                </div>
            </FormularioTour>


            <div className='container-fluid'>
                {
                    items.map(item => {
                        return (<CardHorizontal key={item.id}  {...item} />)
                    })
                }
            </div>

            <FormItinerario horario='8:00am - 4:00 pm' titulo='Incluye' >
                <div>
                    <ul>
                        <li>transporte en vehículo climatizado ida y regreso</li>
                        <li>Recorrido en tren</li>
                    </ul>
                </div>
            </FormItinerario>
        </div>
    )

}